/**
 * Context tags persist as stable vocabulary keys, never as display labels
 * (D-040).
 *
 * Labels are resolved at render time, so wording can change without a
 * migration. The array-of-keys shape also means user-defined tags can be added
 * later without a schema change — custom tags themselves remain deferred under
 * L-009.
 */
export const CONTEXT_TAGS = [
  'highSalt',
  'restaurantMeal',
  'poorSleep',
  'hardLegSession',
  'travel',
  'illness',
  'highStress',
  'lateMeal',
] as const

export type ContextTag = (typeof CONTEXT_TAGS)[number]

/** Bumped when the vocabulary changes; recorded in the `meta` store. */
export const TAG_VOCABULARY_VERSION = 1

export function isContextTag(value: string): value is ContextTag {
  return (CONTEXT_TAGS as readonly string[]).includes(value)
}

/**
 * Display labels. Presentation only — never persisted, never compared against
 * stored data.
 */
export const CONTEXT_TAG_LABELS: Readonly<Record<ContextTag, string>> = {
  highSalt: 'High salt',
  restaurantMeal: 'Restaurant meal',
  poorSleep: 'Poor sleep',
  hardLegSession: 'Hard leg session',
  travel: 'Travel',
  illness: 'Illness',
  highStress: 'Unusually high stress',
  lateMeal: 'Late meal',
}
